import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ClientWorkflows from "Components/Client/Workflows/ClientWorkflows";
import { getAboutClient, getExtraClientInfo } from "API/swesum";
import AboutClient from "./clientcard/AboutClient";
import { EndCustomerContextProvider } from "Context/EndCustomers";
import { ClientContextProvider } from "Context/Client";
import { ClientCard } from "./clientcard/ClientCard";
import Fortnox from "./fortnox/Fortnox";

export function Client() {
  const { clientID } = useParams();

  const [clientPayments, setClientPayments] = useState([]);
  const [aboutData, setAboutData] = useState(null);
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [termsTemplates, setTermsTemplates] = useState([]);
  const [allAgreementTemplates, setAllAgreementTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showWarningLog, setShowWarningLog] = useState(false);
  const [showLogs, setShowLogs] = useState(false);

  useEffect(() => {
    if (logs) {
      for (const log of logs) {
        if (log.UserAction === "Skapat logg manuellt") {
          setShowWarningLog(true);
          break;
        }
      }
    }
  }, [logs]);

  const asyncFetchExtraInfo = async () => {
    setLoading(true);

    if (clientID) {
      setAboutData(await getAboutClient(clientID));

      const data = await getExtraClientInfo(clientID);
      const [
        clientPayments,
        logs,
        users,
        termstemplates,
        getallagreementtemplates,
      ] = data;

      setClientPayments(clientPayments);
      setLogs(logs);
      setUsers(users);
      setTermsTemplates(termstemplates);
      setAllAgreementTemplates(getallagreementtemplates);
    }

    setLoading(false);
  };

  useEffect(() => {
    asyncFetchExtraInfo();
  }, [clientID]);

  return (
    <ClientContextProvider clientId={clientID}>
      <EndCustomerContextProvider clientId={clientID}>
        <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
          <Box sx={{ flexGrow: 1, p: 3 }}>
            <Grid
              container
              rowSpacing={1}
              justifyContent="space-evenly"
              alignItems="stretch"
              columnSpacing={{ xs: 1, sm: 2, md: 1 }}
            >
              <Grid item xs={12} md={9}>
                <ClientCard
                  showWarningLog={showWarningLog}
                  onClickWarningLog={() => setShowLogs(true)}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  gap: "8px",
                }}
              >
                <AboutClient
                  data={aboutData}
                  clientId={clientID}
                  loading={loading}
                />

                <Fortnox clientId={clientID} />
              </Grid>
              <Grid item xs={12} md={12}>
                <ClientWorkflows
                  clientPayments={clientPayments}
                  logs={logs}
                  users={users}
                  termstemplates={termsTemplates}
                  getallagreementtemplates={allAgreementTemplates}
                  selectedLogs={showLogs}
                  resetSelectedLogs={() => setShowLogs(false)}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </EndCustomerContextProvider>
    </ClientContextProvider>
  );
}
